// Ao adicionar mais keycodes, usar http://keycode.info
export const BACKSPACE = "Backspace";
export const COMMA = ",";
export const ENTER = "Enter";
export const SEMICOLON = ";";
export const TAB = "Tab";